import { render, staticRenderFns } from "./InstgramIcon.vue?vue&type=template&id=406aa22c&scoped=true&"
import script from "./InstgramIcon.vue?vue&type=script&lang=js&"
export * from "./InstgramIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406aa22c",
  null
  
)

export default component.exports